export enum ButtonAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}

export const ButtonAlignmentMap = new Map([
  [ButtonAlignment.left, 'Left'],
  [ButtonAlignment.center, 'Center'],
  [ButtonAlignment.right, 'Right'],
]);

export const BUTTON_ALIGNMENT_LOOKUP = [ButtonAlignment.left, ButtonAlignment.center, ButtonAlignment.right].map(
  value => {
    return { value: value, text: ButtonAlignmentMap.get(value), hint: ButtonAlignmentMap.get(value) };
  },
);
